import * as Models from "../.";
export interface IPaymentCaptureCustomer {
    customer: Models.Customer.Customer.ICustomer;
    billingAddress: Models.Customer.Address.Address;
    serviceAddress: Models.Customer.Address.Address;
    paymentInfo: Models.PaymentCapture.PaymentInfo.PaymentProfile;
}

export interface IResidentialPaymentCaptureCustomer extends IPaymentCaptureCustomer {
    rate: number;
    escalator: Models.CostCalculation.Escalator.Escalator;
    igsCustomerNumber: string;
    shouldDisplaySilenceCallRecording: boolean;
    product: string;
    monthlyPayment: number;
}

export class ResidentialPaymentCaptureCustomer implements IResidentialPaymentCaptureCustomer {
    customer: Models.Customer.Customer.Customer;
    billingAddress: Models.Customer.Address.Address;
    serviceAddress: Models.Customer.Address.Address;
    rate: number;
    escalator: Models.CostCalculation.Escalator.Escalator;
    paymentInfo: Models.PaymentCapture.PaymentInfo.PaymentProfile;
    igsCustomerNumber: string;
    shouldDisplaySilenceCallRecording: boolean;
    product: string;
    monthlyPayment: number;
}

export interface ICommunityPaymentCaptureCustomer
    extends IPaymentCaptureCustomer {
    community: ICommunity;
    accountTypeCode: string;
}

export interface IResidentialPaymentCaptureConfirmationRequest {
    customerNumber: string;
}

export interface IResidentialPaymentCaptureCustomerInformationRequest {
    igsCustomerNumber: string;
}

export class ResidentialPaymentCaptureCustomerInformationRequest
    implements IResidentialPaymentCaptureCustomerInformationRequest {
    igsCustomerNumber: string;

    constructor(customerNumber: string) {
        this.igsCustomerNumber = customerNumber;
    }
}

export class ResidentialPaymentCaptureConfirmationRequest
    implements IResidentialPaymentCaptureConfirmationRequest {
    customerNumber: string;
}

export interface IResidentialPaymentCaptureConfirmationResponse {
    paymentCaptureResponse: Models.PaymentCapture.PaymentCaptureResponse.IPaymentCaptureResponse;
    customerName: string;
    opportunityNumber: string;
    address: Models.Customer.Address.Address;
    emailAddress: string;
    phoneNumber: string;
    completionTime: Date;
}

export class CommunityPaymentCaptureCustomer
    implements ICommunityPaymentCaptureCustomer {
    community: ICommunity;
    accountTypeCode: string;
    customer: Models.Customer.Customer.ICustomer;
    billingAddress: Models.Customer.Address.Address;
    serviceAddress: Models.Customer.Address.Address;
    paymentInfo: Models.PaymentCapture.PaymentInfo.PaymentProfile;
}

export interface IAccountType {
    displayName: string;
    accountTypeCode: string;
}

export class AccountType implements IAccountType {
    displayName: string;
    accountTypeCode: string;
}

export interface ICommunity {
    name: string;
    code: string;
}

export class Community implements ICommunity {
    name: string;
    code: string;
}
